<script>
  export let id = "";
</script>

<ul class="app-links">
  <li>
    <a href={'https://store.steampowered.com/app/' + id}>Store</a>
  </li>
  <li>
    <a href={'https://steamcommunity.com/app/' + id}>Hub</a>
  </li>
  <li>
    <a href={'https://steamdb.info/app/' + id}>SteamDB</a>
  </li>
  <li>
    <a href={'https://steamcharts.com/app/' + id}>SteamCharts</a>
  </li>
</ul>
